import { ItemDND } from '@/models/DNDOrdenation';
import { DragIcon } from '../../../../../icons';
import DNDItemContainer from '../../DNDItem/DNDItemContainer';

interface DNDOrdenationItemProps {
  dndOrdenationItem: ItemDND;
}

export default function DNDOrdenationItem({
  dndOrdenationItem,
}: DNDOrdenationItemProps) {
  const { text, image, mediaLink, altText } = dndOrdenationItem;

  return (
    <DNDItemContainer
      text={text}
      image={image}
      mediaLink={mediaLink}
      altText={altText}
    >
      <div>
        <DragIcon data-testid="dragIcon" />
      </div>
    </DNDItemContainer>
  );
}
